// Footer components

export { default as Footer, default } from "./Footer";
export { default as FooterBottom } from "./FooterBottom";
export { default as FooterContact } from "./FooterContact";
export { default as FooterExperience } from "./FooterExperience";
export { default as FooterNewsletter } from "./FooterNewsletter";
export { default as FooterQuote } from "./FooterQuote";
export { default as FooterSocial } from "./FooterSocial";
export { default as FooterStory } from "./FooterStory";
